exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h1-case-feature__text {\n  color: #5f707f;\n  font-size: 16px;\n  line-height: 28px;\n}", ""]);

// exports
